import { checkDeviceResolution } from '../utils/check-device-resolution';

const $window = $(window);
const $cart = $('.js-cart');
const $cartBody = $('.js-cart-body');
const $cartAside = $('.js-cart-aside');

$window.on('load', function () {
  if (checkDeviceResolution.isDesktop && $cartBody.outerHeight() > $window.height()) {
    $cart.addClass('init-fixed-sidebar');
  }
});

$window.on('load scroll', function () {
  if (checkDeviceResolution.isDesktop && $cartBody.length && $cart.hasClass('init-fixed-sidebar')) {
    let cartTop = $cartBody.offset().top;
    let windowTop = $window.scrollTop();
    let headerContentHeight = $('.js-header-content').outerHeight();
    let cartBottom = $cartBody.offset().top + $cartBody.outerHeight();
    let windowBottom = $window.scrollTop() + $window.height();

    // start moving when top reached
    $cartAside.toggleClass('fixed-top', windowTop + headerContentHeight >= cartTop);

    // stop moving when bottom reached
    $cartAside.toggleClass('absolute-bottom', windowBottom >= cartBottom);
  }
});
